var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useMutation } from '@apollo/client/react';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { GetAccessByComposersDocument } from 'app/domains/templates';
import { AddComposerPermissionsDocument } from './AddComposerPermissions.gql';
import { RemoveComposerPermissionsDocument } from './RemoveComposerPermissions.gql';
export function useUpdateComposerPermissions() {
    const { addToast } = useToast();
    const [refetching, setRefetching] = useState(false);
    const [add, addStates] = useMutation(AddComposerPermissionsDocument, {
        refetchQueries: [GetAccessByComposersDocument],
        onQueryUpdated: (query) => {
            setRefetching(true);
            return query.refetch().finally(() => setRefetching(false));
        },
    });
    const [remove, removeStates] = useMutation(RemoveComposerPermissionsDocument, {
        refetchQueries: [GetAccessByComposersDocument],
        onQueryUpdated: (query) => {
            setRefetching(true);
            return query.refetch().finally(() => setRefetching(false));
        },
    });
    const loading = addStates.loading || removeStates.loading;
    const updateComposerPermissions = (options) => __awaiter(this, void 0, void 0, function* () {
        const { type, userIds, composerIds } = options;
        try {
            if (type === 'add') {
                yield add({ variables: { userIds, composerIds } });
            }
            else {
                yield remove({ variables: { userIds, composerIds } });
            }
            addToast({
                title: t({
                    message: 'Updated template access successfully',
                    comment: 'success toast when updating composer access',
                }),
                appearance: 'success',
            });
        }
        catch (_a) {
            addToast({
                title: t({
                    message: 'Something went wrong',
                    comment: 'toast when failing to update composer access',
                }),
                appearance: 'danger',
            });
        }
    });
    return { updateComposerPermissions, loading, refetching };
}
